import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccFinancialIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccFinancialIcon(props: MccFinancialIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccFinancialIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Financial')}
      {...rest}
    >
      <path
        d="M1 10.6666C1 12.1393 2.19391 13.3333 3.66667 13.3333H6.33333C7.80609 13.3333 9 12.1393 9 10.6666C9 9.19383 7.80609 7.99992 6.33333 7.99992H3.66667C2.19391 7.99992 1 6.80601 1 5.33325C1 3.86049 2.19391 2.66659 3.66667 2.66659H6.33333C7.80609 2.66659 9 3.86049 9 5.33325M5 1.33325V14.6666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
